export const APP_DATE_FORMAT = 'MM/DD/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const APP_DATE_FORMAT_INPUT_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
